import { state } from "./state";
import { CHANGAN_FINANCE_ID, creditFields, TRADE_IN_ID, BENEFIT, TRADE_IN_OTHER_ID, DIRECT_SALE_ID} from "./constants";

export const getSale = name => {
  const sales = state.complectation?.sales;

  if (!Array.isArray(sales)) {
    return 0;
  }
  const findById = (id) =>
    sales.find(item => parseInt(item.id) === id)?.value ?? 0;

  switch (name) {
    case 'sale':
      return findById(CHANGAN_FINANCE_ID);

    case 'tradein':
      return findById(TRADE_IN_ID);

    case 'benefit':
      return findById(BENEFIT);

    case 'tradeinother':
      return findById(TRADE_IN_OTHER_ID);

    case 'directsale':
      return findById(DIRECT_SALE_ID);

    default:
      return 0;
  }
};

export const getPacket = () => {
  let price = null;
  state.credits.forEach(credit => {
    if (credit.installment_packet_price && (!price || credit.installment_packet_price < price)) {
      price = credit.installment_packet_price;
    }
  })

  return price;
}

export const getField = name => creditFields.filter((index, { dataset: { finance } }) => finance === name)[0];
